<mat-icon [svgIcon]="icon" class="icon"></mat-icon>
<h3 class="title" [innerHTML]="title"></h3>
<trp-community-info-icon
  *ngIf="infoText"
  [infoText]="infoText"
></trp-community-info-icon>
